<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">That worked!</h1>
			<p>
				Terrific! Have a great term
			</p>
		</div>

		<base-nav-links home no-back></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './components/BaseNavLinks';

	export default {
		name: "Yahoo",

		components: {
			BaseNavLinks,
		},
	}
</script>

<style scoped>

</style>